/** #1232: a saved US exposure remains reachable without inventing a game. */
export interface UsInventorySelection { accountId: string; marketSlug: string; outcome: 'yes' | 'no' }
const ACCOUNT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const SLUG = /^[A-Za-z0-9_-]{1,256}$/;
const KEYS = ['usAccount', 'usMarket', 'usOutcome'] as const;
export function usInventorySelection(params: URLSearchParams): UsInventorySelection | null {
  if (KEYS.some(key => params.getAll(key).length !== 1)) return null;
  const accountId = params.get('usAccount')!, marketSlug = params.get('usMarket')!, outcome = params.get('usOutcome');
  return ACCOUNT.test(accountId) && SLUG.test(marketSlug) && (outcome === 'yes' || outcome === 'no')
    ? { accountId, marketSlug, outcome } : null;
}
export function usInventoryHref(target: UsInventorySelection): string | null {
  const query = new URLSearchParams({ usAccount: target.accountId, usMarket: target.marketSlug, usOutcome: target.outcome });
  return usInventorySelection(query) ? `/positions?${query}` : null;
}
export function withoutUsInventorySelection(params: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(params); for (const key of KEYS) next.delete(key); return next;
}
